export default __webpack_public_path__ + "static/media/Second View.38a07852.jpg";